import type { Theme } from '../src/theme/getTheme'

const ROW_PADDING_H = 12
const LIST_PADDING_H = 12

export const getGroupLeaderboardSectionsStyleSheet = (theme: Theme) => ({
  challengeHistorySection: {
    marginTop: 24,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: theme.gray[200],
    paddingHorizontal: 0,
  },
  challengeHistoryTitle: {
    fontSize: 18,
    fontWeight: '700' as const,
    color: theme.gray[900],
    marginBottom: 16,
    paddingHorizontal: ROW_PADDING_H,
  },
  challengeHistoryCardWrap: {
    marginBottom: 16,
    paddingHorizontal: ROW_PADDING_H,
  },
  challengeHistoryEmpty: {
    paddingVertical: 24,
    paddingHorizontal: ROW_PADDING_H,
    alignItems: 'center' as const,
  },
  challengeHistoryEmptyText: {
    fontSize: 15,
    color: theme.gray[600],
    textAlign: 'center' as const,
  },
  challengeHistoryShowMoreButton: {
    marginTop: 8,
    marginBottom: 16,
    paddingVertical: 12,
    paddingHorizontal: 20,
    alignSelf: 'center' as const,
    backgroundColor: theme.primary + '20',
    borderRadius: 12,
  },
  challengeHistoryShowMoreButtonPressed: { opacity: 0.8 },
  challengeHistoryShowMoreButtonHover: { opacity: 0.9 },
  challengeHistoryShowMoreText: {
    fontSize: 15,
    fontWeight: '600' as const,
    color: theme.primary,
  },
  challengeHistoryLoadMoreFooter: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    alignItems: 'center' as const,
  },
  challengeHistoryLoadMoreText: {
    fontSize: 14,
    color: theme.gray[600],
  },
  joinableSection: {
    paddingHorizontal: LIST_PADDING_H,
    paddingTop: 16,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: theme.gray[200],
    backgroundColor: theme.background.primary,
  },
  joinableTitle: {
    fontSize: 18,
    fontWeight: '700' as const,
    color: theme.gray[900],
    marginBottom: 12,
  },
  joinableCard: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const,
    paddingVertical: 12,
    paddingHorizontal: ROW_PADDING_H,
    marginBottom: 8,
    backgroundColor: theme.cardActiveBg,
    borderRadius: 16,
    shadowColor: theme.shadow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
  },
  joinableCardLeft: {
    flex: 1,
    marginRight: 12,
  },
  joinableCardName: {
    fontSize: 14,
    fontWeight: '600' as const,
    color: theme.gray[900],
  },
  joinableCoinRow: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    gap: 4,
    marginTop: 2,
  },
  joinableCoinText: {
    fontSize: 12,
    fontWeight: '600' as const,
    color: theme.accentDark,
  },
  joinableAcceptButton: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 12,
    backgroundColor: theme.primary,
    minWidth: 88,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  joinableAcceptButtonDisabled: {
    opacity: 0.7,
  },
  joinableAcceptButtonPressed: { opacity: 0.7 },
  joinableAcceptButtonHover: { opacity: 0.9 },
  joinableAcceptButtonText: {
    fontSize: 14,
    fontWeight: '600' as const,
    color: theme.white,
  },
})
